import * as React from 'react'

function PubPlus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48"
      height="48"
      fill="none"
      ref={svgRef}
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#202022"
          d="M24 47.52c12.99 0 23.52-10.53 23.52-23.52S36.99.48 24 .48.48 11.01.48 24 11.01 47.52 24 47.52Z"
        />
        <path
          fill="#F3FE82"
          d="M39.546 22.945v-2.998h-1.955v2.998h-2.468a5.47 5.47 0 0 1 0 1.956h2.468v2.997h1.955v-2.997h2.998v-1.955h-2.998v-.001Zm-9.556-3.296c-.885 0-1.708.266-2.396.721v-4.29h-1.955v7.951h.001a4.356 4.356 0 0 0 4.35 4.318 4.356 4.356 0 0 0 4.352-4.35 4.359 4.359 0 0 0-4.353-4.35Zm0 6.746A2.398 2.398 0 0 1 27.593 24a2.397 2.397 0 0 1 2.395-2.395A2.397 2.397 0 0 1 32.384 24a2.399 2.399 0 0 1-2.395 2.395Zm-5.22-6.747v4.569a4.133 4.133 0 0 1-8.266 0v-4.569h1.952v4.586a2.182 2.182 0 0 0 4.363 0v-4.586h1.95Zm-13.364 0a4.356 4.356 0 0 0-4.35 4.318v7.951H9.01v-4.29c.687.456 1.51.721 2.395.721a4.355 4.355 0 0 0 4.35-4.35 4.354 4.354 0 0 0-4.35-4.35Zm0 6.747A2.398 2.398 0 0 1 9.01 24a2.398 2.398 0 0 1 2.395-2.396A2.397 2.397 0 0 1 13.8 24a2.398 2.398 0 0 1-2.395 2.395Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

const ForwardRef = React.forwardRef(PubPlus)
export default ForwardRef
